import axios from 'axios';
import { AuthenticationResponse } from 'data/schemas/auth';

export async function retrieveMasterEmployee(params: { citizenId: string }) {
    return axios.get<AuthenticationResponse[]>('v1/getuser', {
        params
    });
}
